import { useQuery } from '@apollo/client/react';

import { Platform } from 'src/__generated__/graphql';
import { useConfig } from 'src/context/config';
import { useAuth } from 'src/context/useAuth';
import { useJobId } from 'src/context/useJobId';
import { GET_JOB_APPLICATION_PROCESS } from 'src/modules/graphql-client/queries/jobs.graphql';

export const useApplicationProcess = () => {
  const { jobId } = useJobId();
  const { isAuth } = useAuth();
  const { config } = useConfig();

  const { data, loading, error } = useQuery(GET_JOB_APPLICATION_PROCESS, {
    variables: {
      fetchRequiredVerifications: true,
      jobId,
      isAuthenticated: isAuth,
      locale: config.VOCAB_LANGUAGE,
      platform: Platform.Web,
    },
    errorPolicy: 'all', // This is needed for useInitApp.test.tsx - should not log errors for non-loggable paths
  });

  return {
    data: data?.jobApplicationProcess,
    loading,
    error,
  };
};
